import { CommonModule } from '@angular/common'
import { Component } from '@angular/core'

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'button-spinner',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './button-spinner.component.html',
  styleUrls: ['./button-spinner.component.scss'],
})
export class ButtonSpinnerComponent {}
